// Node naming: default icons and handles from titles. No schemas here, so the browser entry can use it
// without pulling in zod.

import { FORMULA_FUNCTIONS } from "./formula";

export const DEFAULT_ICON = { event: "circle-dot", metric: "chart-line" } as const;

const RESERVED = new Set<string>(FORMULA_FUNCTIONS);

/** A handle derived from a title: "Acme revenue" → "acme_revenue". */
export function slugHandle(title: string): string {
	let s = title
		.toLowerCase()
		.normalize("NFKD")
		.replace(/[^a-z0-9]+/g, "_")
		.replace(/^_+|_+$/g, "")
		.slice(0, 40)
		.replace(/_+$/g, "");
	if (!s) s = "node";
	if (!/^[a-z]/.test(s)) s = `n_${s}`;
	if (RESERVED.has(s)) s = `${s}_node`;
	return s;
}

/** `base`, or `base_2`, `base_3`, … whichever is not taken. */
export function uniqueHandle(base: string, taken: Set<string> | ((h: string) => boolean)): string {
	const has = typeof taken === "function" ? taken : (h: string) => taken.has(h);
	if (!has(base)) return base;
	for (let i = 2; ; i++) {
		const h = `${base.slice(0, 60)}_${i}`;
		if (!has(h)) return h;
	}
}
